@if (store.cities().length && store.destinations().length && store.transport() && !store.someRequestIsLoading()) {
	<app-top-bar
		[transportId]="store.transport().id"
		[module]="TransportModule.MAP"
		[side]="store.transport().side"
		[kind]="store.transport()?.kind"
		[buttonsDisabled]="store.transportAction() === TransportAction.ADD"
		[transportName]="store.transport().name"
		[transportsToLinkNames]="store.transportsToLinkNames()"
		(saveTransportMapEvent)="saveTransportMap()"
		(changedTransportName)="changeTransportName($event)"
	>
		<button (click)="triggerHistoryAction('undo')" class="btn btn-primary text-small">
			<i class="fa fa-rotate-left"></i> Cofnij
		</button>
		<button (click)="triggerHistoryAction('redo')" class="btn btn-primary text-small">
			<i class="fa fa-rotate-right"></i> Przywróć
		</button>

		<button class="btn btn-primary text-small" (click)="toggleSidenav()"><i class="fa fa-bus"></i> Pojazdy</button>
	</app-top-bar>

	<app-vehicles-sidenav
		[showOnlyVirtualVehicles]="
			(store.transportAction() === TransportAction.ADD && !store.transportsToLink().length) ||
			store.transport()?.kind === TransportKind.TEMPLATE
		"
		class="position-relative"
	>
		<div class="position-relative">
			<app-vehicle-in-use></app-vehicle-in-use>
		</div>
		<app-transport-map-timeline></app-transport-map-timeline>
		<app-city-map [cities]="store.citiesWithPrograms()" [vehicleInUse]="store.vehicleInUse()"></app-city-map>
		<hr />
		<app-map-destination
			[destinations]="store.destinations()"
			[vehicleInUseSelected]="!!store.vehicleInUse()"
			(destinationSelected)="includeDestinationInRoute($event)"
		></app-map-destination>
	</app-vehicles-sidenav>
} @else {
	<div class="w-100 vh-100">
		<app-custom-mat-loader></app-custom-mat-loader>
	</div>
}
